<template>
	<div class="filter-container">
		<IconButton
			iconStyle="far"
			iconName="sliders-h"
			size="large"
			aria-label="filter options"
			@onClick="toggleFilterMenu"
		/>
		<span class="counter" v-if="counter > 0">{{ counter }}</span>
		<transition name="fade">
			<div class="menu-container" v-if="showFilterMenu">
				<div class="menu-header">
					<h3 class="heading">Filters</h3>
					<TextButton
						@onClick="handleResetButtonClick"
						aria-label="Reset filters"
						>Reset</TextButton
					>
				</div>

				<div
					v-for="(option, index) in filterOptions"
					:key="index"
					class="filter-options"
				>
					<h3 class="heading">{{ option.type }}</h3>
					<div class="button-container">
						<FilterButton
							v-for="(filter, index) in option.data"
							:key="index"
							:name="filter.statusDesc"
							:aria-label="`Filter by ${filter.statusDesc}`"
							:selected="isSelected(option.type, filter)"
							@onClick="handleFilterButtonClick(option.type, filter)"
						/>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import FilterButton from '@/components/global/FilterButton.vue';
import IconButton from '@/components/global/IconButton.vue';
import TextButton from '@/components/global/TextButton.vue';

import { TYPES } from './constants.js';

export default {
	name: 'DripCampaignContactsFilterMenu',
	props: {
		filterOptions: Array,
	},
	components: {
		FilterButton,
		IconButton,
		TextButton,
	},
	data() {
		return {
			counter: 0,
			showFilterMenu: false,
			statusIds: [],
		};
	},
	methods: {
		handleFilterButtonClick(type, filter) {
			if (type === TYPES.STATUS) {
				if (this.statusIds.includes(filter.statusId)) {
					this.statusIds = this.statusIds.filter(
						(ele) => ele !== filter.statusId,
					);
				} else {
					this.statusIds.push(filter.statusId);
				}
			}

			this.setCounter();
			this.$emit('onFilterChange', this.statusIds);
		},
		handleResetButtonClick(filterName) {
			this.statusIds = [];
			this.setCounter();
			this.$emit('onFilterChange', this.statusIds);
		},
		isSelected(type, filter) {
			if (type === TYPES.STATUS) {
				return this.statusIds.includes(filter.statusId);
			} else {
				return false;
			}
		},
		setCounter() {
			let count = 0;
			const filterCategories = {
				status: this.statusIds,
			};
			for (const category in filterCategories) {
				if (filterCategories[category].length > 0) {
					count += 1;
				}
			}
			if (this.counter !== count) {
				this.counter = count;
			}
		},
		toggleFilterMenu() {
			this.showFilterMenu = !this.showFilterMenu;
		},
		windowClickHandler(e) {
			if (!this.$el.contains(e.target) && this.showFilterMenu) {
				this.showFilterMenu = false;
			}
		},
	},
	mounted() {
		window.addEventListener('click', this.windowClickHandler);
	},
	beforeDestroy() {
		window.removeEventListener('click', this.windowClickHandler);
	},
};
</script>

<style lang="scss" scoped>
.filter-container {
	position: relative;

	.menu-container {
		box-sizing: border-box;
		background-color: $white;
		border-radius: $b360-border-radius-large;
		border: 1px solid $border-color-light;
		box-shadow: 0 3px 10px $shadow-color;
		z-index: 2;
		position: absolute;
		top: calc(100% + 10px);
		right: 0;
		opacity: 1;
		@include rem('width', 320px);

		.menu-header {
			display: flex;
			@include rem('padding', 16px);
			justify-content: space-between;
			border-bottom: 1px solid $border-color-light;

			.heading {
				margin: 0;
				@include rem('font-size', 16px);
			}
		}

		.filter-options {
			@include rem('padding', 10px 16px);
			border-top: 1px solid $border-color-light;

			.button-container {
				@include rem('margin-top', 10px);

				.filter-button {
					@include rem('margin-right', 8px);
					@include rem('margin-bottom', 8px);
				}
			}
		}
	}

	.counter {
		background: $brand-blue;
		color: $white;
		font-weight: bold;
		line-height: 1;
		position: absolute;
		top: -13px;
		right: -13px;
		border-radius: 6px;
		display: flex;
		justify-content: center;
		align-items: center;
		@include rem('font-size', 14px);
		@include rem('width', 26px);
		@include rem('height', 26px);
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.15s ease;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	.lo-filter-container {
		@include rem('padding', 16px);

		.lo-filter-button {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 500;
			cursor: pointer;

			.right-content {
				display: flex;

				.filter-count {
					color: $white;
					background: $brand-blue;
					display: flex;
					justify-content: center;
					align-items: center;
					@include rem('height', 22px);
					@include rem('width', 20px);
					@include rem('margin-right', 8px);
					@include rem('padding-bottom', 1px);
					@include rem('border-radius', 6px);
				}
			}
		}
	}
}
</style>
